module.exports = __webpack_public_path__ + "img/message_logo.9f6216ed.png";